export enum Authorisation {
    Admin = "Admin",
    Write = "Write",
    Read = "Read",
    Deny = "Deny",
    None = "None",
    Break = "Break",
    PermanentBreak = "PermanentBreak",
    Lock = "Lock"
}